// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zjcFR","label":"styles_label__zjOD7"};